/**
 * @file ppde页面
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback} from 'react';
import {Button} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import A from '../../components/a/A';
import Banner from './components/banner/Banner';
import Members from './components/members/Members';
import FeaturedCases from './components/featured-cases/FeaturedCases';


import titleMembers from './image/title-members.png';
import titleFeaturedCases from './image/title-featured-cases.png';
import titleExclusiveRight from './image/title-exclusive-right.png';
import titleAbout from './image/title-about-us.png';
import exclusiveRightImg from './image/exclusive-right.png';
import advanceRightImg from './image/advance-right.png';

import AboutUs from './components/about-us/AboutUs';

import usePpdeHooks from './ppdeHooks';
import PpdeHeader from './components/ppde-header/PpdeHeader';
import BannerPictureCardGroup from './components/banner-picture-card/BannerPictureCardGroup';

const Ppde: React.FC = () => {
    const {
        bannerPictureCard,
        members,
        featuredCase,
        aboutUs
    } = usePpdeHooks();

    const onJoinClick = useCallback(() => {
        if ((window as any)._hmt) {
            (window as any)._hmt.push([
                '_trackEvent',
                'ppde',
                '申请加入',
                'banner点击申请加入'
            ]);
        }
    }, []);

    return (
        <div className="page paddle-ppde-page">
            <Header />
            <PpdeHeader />
            <span className="anchor" id="PPDE首页" />
            <Banner className="paddle-ppde-banner">
                <div className="paddle-ppde-banner-btn-group">
                    <A href="https://paddle.wjx.cn/jq/81813009.aspx" onClick={onJoinClick}>
                        <Button
                            className="paddle-ppde-banner-btn"
                            type="primary"
                            size="large"
                        >
                            申请加入
                        </Button>
                    </A>
                    <A
                        className="paddle-ppde-banner-btn-link"
                        href="https://aistudio.baidu.com/aistudio/index"
                        target
                    >
                        了解飞桨开源社区
                    </A>
                </div>
            </Banner>
            <div className="paddle-ppde-page-background">
                <div className="paddle-ppde-page-container">
                    <span className="anchor" id="PPDE导航卡片" />
                    <BannerPictureCardGroup {...bannerPictureCard} />
                </div>
                <div className="paddle-ppde-page-container">
                    <span className="anchor" id="PPDE成员" />
                    <div
                        className="paddle-ppde-page-title"
                        style={{backgroundImage: `url(${titleMembers})`}}
                    />
                    <Members {...members} />

                    <div className="paddle-ppde-page-more-link-wrap">
                        <A
                            className="paddle-ppde-page-more-link"
                            href="/ppdeml"
                        >
                            了解更多成员
                        </A>
                    </div>
                </div>
                <div className="paddle-ppde-page-container">
                    <span className="anchor" id="PPDE精选项目" />
                    <div
                        className="paddle-ppde-page-title"
                        style={{backgroundImage: `url(${titleFeaturedCases})`}}
                    />
                    <FeaturedCases {...featuredCase} />

                    <div className="paddle-ppde-page-more-link-wrap">
                        <A
                            className="paddle-ppde-page-more-link"
                            href="/customercase"
                            target
                        >
                            了解更多项目
                        </A>
                    </div>
                </div>
                <div className="paddle-ppde-page-container">
                    <span className="anchor" id="PPDE专属权益" />
                    <div
                        className="paddle-ppde-page-title"
                        style={{backgroundImage: `url(${titleExclusiveRight})`}}
                    />
                    <img
                        className="paddle-ppde-exclusive-right-img"
                        alt="专属权益"
                        src={exclusiveRightImg}
                    />
                    <div className="paddle-ppde-page-h2">
                        PPDE权益进阶
                    </div>
                    <img
                        className="paddle-ppde-advance-right-img"
                        alt="进阶权益"
                        src={advanceRightImg}
                    />
                </div>
                <div className="paddle-ppde-page-container">
                    <span className="anchor" id="关于我们" />
                    <div
                        className="paddle-ppde-page-title"
                        style={{backgroundImage: `url(${titleAbout})`}}
                    />
                    <div className="paddle-ppde-page-h3">
                        PPDE（PaddlePaddle Developers Experts）
                        是飞桨开发者技术专家的荣誉认证体系，秉持开源理念，PPDE面向所有开发者敞开大门，只要你对开源有热情并愿意为之分享和付出，PPDE便能回馈你更多。
                    </div>
                    <AboutUs {...aboutUs} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Ppde;
